export default {
  createButton: { id: 'create_button' },
  applicationList: { id: 'application_list' },
  application: { id: 'application' },
  applications: { id: 'applications' },
  licensees: { id: 'licensees' },
  applicationInfo: { id: 'application_info' },
  createApplication: { id: 'create_application' },
  editApplication: { id: 'edit_application' },
  deleteApplication: { id: 'delete_application' },
  deleteApplicationMessage: { id: 'delete_application_message' },
  name: { id: 'name' },
  description: { id: 'description' },
  url: { id: 'url' },
  active: { id: 'active' },
  dateUpdated: { id: 'date_updated' },
}
